import { isFreemiumExperiment } from '../products';

import {
  desktopFeatureLabels as desktopFeatureLabelsBase,
  sortDesktopFeatures as sortDesktopFeaturesBase,
} from './desktop';
import {
  desktopFeatureLabels as desktopFeatureLabelsFreemium,
  sortDesktopFeatures as sortDesktopFeaturesFreemium,
} from './freemium';

export type DesktopFeatureConfig =
  | 'enabled'
  | 'disabled'
  | 'addOn450'
  | 'addOn650'
  | 'payPerEnquiry'
  | '6month'
  | 'lus';

export type DesktopFeatures = {
  duration?: DesktopFeatureConfig;
  boostedAds?: DesktopFeatureConfig;
  price?: DesktopFeatureConfig;
  refresh?: DesktopFeatureConfig;
  tools?: DesktopFeatureConfig;

  listing?: DesktopFeatureConfig;
  connections?: DesktopFeatureConfig;
  photo?: DesktopFeatureConfig;
  searchRank?: DesktopFeatureConfig;
  boostedEmail?: DesktopFeatureConfig;
  featuredSearch?: DesktopFeatureConfig;
  featuredEmail?: DesktopFeatureConfig;
};

export const sortDesktopFeatures = isFreemiumExperiment
  ? sortDesktopFeaturesFreemium
  : sortDesktopFeaturesBase;
export const desktopFeatureLabels = isFreemiumExperiment
  ? desktopFeatureLabelsFreemium
  : desktopFeatureLabelsBase;
